/**
 * Utilidades para manejo de fechas en zona horaria de Ecuador (UTC-5)
 */

/**
 * Convierte una fecha a formato YYYY-MM-DD en zona horaria de Ecuador (UTC-5)
 * Evita problemas de zona horaria que ocurren con toISOString()
 * @param {Date} fecha - La fecha a convertir
 * @returns {string} Fecha en formato YYYY-MM-DD
 */
export const formatearFechaLocal = (fecha) => {
  if (!fecha) return '';
  
  // Ajuste para evitar el problema de zona horaria
  // Usamos UTC para evitar la conversión automática que causa el problema de -1 día
  const year = fecha.getUTCFullYear();
  const month = String(fecha.getUTCMonth() + 1).padStart(2, '0');
  const day = String(fecha.getUTCDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};

/**
 * Obtiene la fecha actual en formato YYYY-MM-DD en zona horaria de Ecuador (UTC-5)
 * @returns {string} Fecha actual en formato YYYY-MM-DD
 */
export const obtenerFechaActualLocal = () => {
  // Crear fecha actual
  const fechaActual = new Date();
  // Ajustar a UTC para evitar problemas de zona horaria
  return formatearFechaLocal(fechaActual);
};

/**
 * Ajusta una fecha para Ecuador considerando la zona horaria UTC-5
 * Útil cuando se necesita enviar fechas al backend
 * @param {Date} fecha - La fecha a ajustar
 * @returns {string} Fecha ajustada en formato YYYY-MM-DD
 */
export const ajustarFechaParaEcuador = (fecha) => {
  if (!fecha) return '';
  
  // Ajuste para evitar el problema de zona horaria
  // Usamos UTC para evitar la conversión automática que causa el problema de -1 día
  const year = fecha.getUTCFullYear();
  const month = String(fecha.getUTCMonth() + 1).padStart(2, '0');
  const day = String(fecha.getUTCDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};

/**
 * Convierte una fecha string a objeto Date en zona horaria de Ecuador (UTC-5)
 * @param {string} fechaString - Fecha en formato YYYY-MM-DD
 * @returns {Date} Objeto Date en zona horaria de Ecuador
 */
export const parsearFechaLocal = (fechaString) => {
  if (!fechaString) return null;
  
  const [year, month, day] = fechaString.split('-').map(Number);
  // Crear fecha con año, mes y día específicos usando UTC
  // Esto evita problemas de zona horaria
  const fecha = new Date(Date.UTC(year, month - 1, day));
  
  return fecha;
};